import React, { useEffect, useState } from 'react';
import { View, Text, StyleSheet, StatusBar, TouchableOpacity, ScrollView, Image, Platform, Linking, BackHandler, } from 'react-native';
import Btn from "../components/btn"
import Colors from '../constants/Colors';
import { Ionicons, MaterialCommunityIcons } from "@expo/vector-icons"
import { Modal, NativeBaseProvider, useMediaQuery } from 'native-base';









const OrderColor = (props) => {


    function handleBackButtonClick() {
        // props.navigation.pop()
        props.navigation.navigate("orderlist", {
            refresh: "true"
        })
        return true;

    }

    useEffect(() => {
        BackHandler.addEventListener("hardwareBackPress", handleBackButtonClick);
        return () => {
            BackHandler.removeEventListener("hardwareBackPress", handleBackButtonClick);
        };
    }, []);


    const baseUrl = "https://dl.dasterang.ir/ssdteam/npln/"

    const handleOpenWithLinking = (msg) => {
        Linking.openURL(baseUrl + msg);
    };


    // console.log(props.route.params.file);

    const handleOpenlinkpayment = (threeD_id) => {
        Linking.openURL("https://npln.ir/three/" + threeD_id);
    };

    const [isSmallScreen] = useMediaQuery({
        // minHeight: 280,
        // maxHeight: 480,
        maxWidth:500
      });

      //console.log(props.route.params.file);

    return (

        <NativeBaseProvider>



<View style={{
                width: isSmallScreen ? "100%" : 500,
                height: "100%",
                marginLeft: isSmallScreen ? 0 : "35%",
                backgroundColor: Colors.background,
                position: Platform.OS == "web" ? "fixed" : "relative"
            }}>


                <View style={styles.viewHeader}>
                    <StatusBar backgroundColor={Colors.primary} />
                    <TouchableOpacity onPress={() => props.navigation.navigate("orderlist", {
                        refresh: "true"
                    })} style={styles.menu}   >
                        <Ionicons name="arrow-forward-outline" size={25} color={Colors.background} />
                    </TouchableOpacity>

                    <TouchableOpacity onPress={() => props.navigation.navigate("orderlist", {
                        refresh: "true"
                    })} style={styles.textheader}>
                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.background, padding: "5%" }}>
                            لیست دانلود ها
                        </Text>
                    </TouchableOpacity>

                </View>

<ScrollView>



                <View style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "space-between", width: "100%", padding: 5, }}>



                    {
                    props.route.params.name=="" ?
                    
                    
                    
                    props.route.params.file.map((index, i) => {

                        return (
                            <TouchableOpacity key={i} onPress={() => {


                                // handleOpenWithLinking(index.address)
                                props.navigation.navigate("web", {
                                    addressweb: baseUrl + index.address,
                                    type:index.size
                                })


                            }} style={{ width: "32%", height: 150, borderWidth: 1, borderColor: Colors.secondText3, justifyContent: "center", alignItems: "center",marginBottom:5 }}>
                                {index.size == "jpg" || index.size == "png" || index.size == "jpeg"|| index.mims == "jfif" ?
                                    <Image source={{ uri: "https://npln.ir" + index.name }} alt={index.type} style={{ width: "100%", height: "100%", }} />

                                    :
                                    index.size == "m4a" || index.size == "mp3" || index.size == "mpeg" ?

                                        <MaterialCommunityIcons name="microphone" size={130} color={Colors.primary} />

                                        : index.size == "mp4" ?
                                            <MaterialCommunityIcons name="file-video" size={130} color={Colors.primary} />
                                            
                                            :
                                            <MaterialCommunityIcons name="file-download" size={130} color={Colors.primary} />


                                }



                            </TouchableOpacity>
                        )
                    })
                    :
                    props.route.params.file3D.map((index, i) => {
                       
                        return (
                            <TouchableOpacity key={i} onPress={() => {


                                handleOpenlinkpayment(index.id)



                            }} style={{ width: "32%", height: 150, borderWidth: 1, borderColor: Colors.secondText3, justifyContent: "center", alignItems: "center",marginBottom:5 }}>
                               
                                    <Image source={{ uri: "https://npln.ir" + index.name }} alt={index.type} style={{ width: "100%", height: "100%", }} />

                                    





                            </TouchableOpacity>
                        )
                    })
                
                }






                </View>

                


</ScrollView>








            </View>
        </NativeBaseProvider>


    );
}

const styles = StyleSheet.create({

    viewContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: Colors.background,
        position: Platform.OS == "web" ? "fixed" : "relative"
    },
    viewHeader: {
        flexDirection: "row",
        width: "100%",
         height: Platform.OS == "web" ? 60 : 80,
        backgroundColor: Colors.primary,
    },
    viewmodal: {
        flexDirection: 'row',
        width: "100%",
        height: 55,

        backgroundColor: Colors.background
    },
    viewfooter: {
        position: "absolute",
        bottom: 0,
        flexDirection: "row",
        width: "100%",
        height: 60,
        backgroundColor: Colors.background,

        justifyContent: "center"



    },
    menu: {
        backgroundColor: Colors.primary,
        width: 40,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: 15,
        top: Platform.OS == "web" ?"20%": "35%",

    },
    textheader: {
        backgroundColor: Colors.primary,
        width: 120,
        height: Platform.OS == "web" ? 40 : 60,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        right: "12%",
        top: "22%"
    },
    viewlogo: {
        width: "100%",
        height: 40,
        alignItems: "center",
        justifyContent: "center",
        marginTop: "10%"
    },


    texttitel: {
        fontFamily: "MontserratBold",
        fontSize: 20,
        bottom: 30,
        position: "absolute"
    },
    text: {
        fontFamily: "Montserrat",
        fontSize: 14,
        color: Colors.secondText3,
        textAlign: "right",
        marginTop: 30,
    },
    touch: {
        flexDirection: "column",
        alignItems: "center",
        width: "90%", height: 180,
        backgroundColor: Colors.background1,
        marginTop: 10,
        marginBottom: 10,
        left: "5%",
        borderRadius: 10,
        borderWidth: 1,
        borderColor: Colors.secondText3

    },

    texttouch: {
        fontFamily: "Montserrat",
        fontSize: 12,
        color: Colors.secondText3,


    }
})




export default OrderColor